import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Inventory } from "@mui/icons-material";
import { PARTS_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../contexts/auth";

export default function StockStatusList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewParts = useHasPermission("service.view_part");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "name",
      headerName: t("Name"),
    },
    {
      field: "code",
      headerName: t("Code"),
    },
    {
      field: "unit",
      headerName: t("Unit"),
    },
    {
      field: "stock_quantity",
      headerName: t("Stock Quantity"),
      type: "number",
    },
    {
      field: "notification_threshold",
      headerName: t("Notification Threshold"),
      type: "number",
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/stock-status/${id}`);
  };

  if (!canViewParts) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Inventory />}
      title={t("Stock Status")}
      url={PARTS_ENDPOINT}
      gridSettingsKey="STOCK_STATUS"
      columns={columns}
      refreshEventName="partAdded"
      onRowClick={handleRowClick}
    />
  );
}
